import React from "react";
import { Card, CardBody } from "reactstrap";
import noImage from "assets/images/PicUpload.jpg";
const DiscountDetails = ({ order }) => {
  return (
    <Card>
      {" "}
      <CardBody className="p-2">
        <div className="bg-light p-1">
          <p className="mb-0">Discount Details</p>
        </div>
        <div className="d-flex align-item-center flex-wrap">
          <div className="me-3 mt-3 ps-3">
            <img
              src={
                order?.discountInfo?.bannerImage
                  ? order?.discountInfo?.bannerImage
                  : noImage
              }
              width={"80px"}
              height={"80px"}
              className="rounded-circle"
            />
            <h6 className="text-center mt-3 fw-bold">
              {order?.discountInfo?.title}
            </h6>
          </div>
          <div className="d-flex justify-content-start mb-0 mt-2 p-1">
            <div className="me-5">
              <p className="">Discount Code</p>
              {order?.discountInfo?.discountType ? (
                <p className="">Discount Type</p>
              ) : (
                ""
              )}
              <p className="">Discount Amount</p>
              {order?.discountInfo?.discountType === "Percentage" ? (
                <p className="">Discount Percentage in Amount</p>
              ) : (
                ""
              )}
            </div>

            <div className="text-end ms-5">
              <p className="">{order?.discountInfo?.code}</p>
              <p className="">{order?.discountInfo?.discountType}</p>
              <p className="">
                {" "}
                {order?.discountInfo?.discountType === "Amount" ? "₹" : ""}
                {order?.discountInfo?.discountAmount}
                {order?.discountInfo?.discountType === "Percentage" ? "%" : ""}
              </p>
              {order?.discountInfo?.discountType === "Percentage" ? (
                <p className="">
                  ₹ {order?.orderPaymentInfo?.discountAmount?.toFixed(2)}
                </p>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
      </CardBody>
    </Card>
  );
};

export default DiscountDetails;
